import type { Brand } from '../types/project'

const ROBOTO = "'Roboto', system-ui, sans-serif"

export const brands: Record<string, Brand> = {
  certifieddevs: {
    logo: 'certifieddevs',
    site: 'https://certifieddevs.com',
    radius: '0.9rem',
    displayFont: ROBOTO,
    bodyFont: ROBOTO,
    dark: {
      bg: '#0b0f1a',
      surface: '#121a2b',
      surfaceAlt: '#182236',
      border: '#232e46',
      text: '#f4f7fb',
      textDim: '#98a5bd',
      accent: '#f03e45',
      onAccent: '#ffffff',
      tint: 'rgba(240, 62, 69, 0.14)',
    },
    light: {
      bg: '#f6f7f9',
      surface: '#ffffff',
      surfaceAlt: '#f1f3f6',
      border: '#e1e5ec',
      text: '#0b0f1a',
      textDim: '#59637a',
      accent: '#d92b33',
      onAccent: '#ffffff',
      tint: 'rgba(217, 43, 51, 0.08)',
    },
  },
  'laravel-certification': {
    logo: 'laravel',
    site: 'https://certificationforlaravel.com',
    radius: '1rem',
    displayFont: ROBOTO,
    bodyFont: ROBOTO,
    dark: {
      bg: '#131316',
      surface: '#1b1b1f',
      surfaceAlt: '#232328',
      border: '#2f2f36',
      text: '#fafafa',
      textDim: '#a1a1aa',
      accent: '#ff4032',
      onAccent: '#ffffff',
      tint: 'rgba(255, 64, 50, 0.16)',
    },
    light: {
      bg: '#f4f4f5',
      surface: '#ffffff',
      surfaceAlt: '#fafafa',
      border: '#e4e4e7',
      text: '#18181b',
      textDim: '#5b5b63',
      accent: '#ff2d20',
      onAccent: '#ffffff',
      tint: 'rgba(255, 45, 32, 0.08)',
    },
  },
  nexioapp: {
    logo: 'nexio',
    site: 'https://nexioapp.cloud',
    radius: '0.85rem',
    displayFont: ROBOTO,
    bodyFont: ROBOTO,
    dark: {
      bg: '#08192a',
      surface: '#0e2438',
      surfaceAlt: '#132d45',
      border: '#1d3d59',
      text: '#eaf6f8',
      textDim: '#8fb0c4',
      accent: '#4fd1c5',
      onAccent: '#06232b',
      tint: 'rgba(79, 209, 197, 0.16)',
    },
    light: {
      bg: '#e8f7f5',
      surface: '#ffffff',
      surfaceAlt: '#f3fbfa',
      border: '#c8dce7',
      text: '#0c2a43',
      textDim: '#4a6b85',
      accent: '#0b4a7f',
      onAccent: '#ffffff',
      tint: 'rgba(79, 209, 197, 0.2)',
    },
  },
  'futura-summit': {
    logo: 'futura',
    site: 'https://futurasummit.org',
    radius: '0.25rem',
    displayFont: ROBOTO,
    bodyFont: ROBOTO,
    displayUppercase: true,
    dark: {
      bg: '#191919',
      surface: '#212121',
      surfaceAlt: '#2a2a2a',
      border: '#3a3a3a',
      text: '#ffffff',
      textDim: '#a6a6a6',
      accent: '#2be08d',
      onAccent: '#06231a',
      tint: 'rgba(43, 224, 141, 0.14)',
    },
    light: {
      bg: '#f5f6f5',
      surface: '#ffffff',
      surfaceAlt: '#eef0ee',
      border: '#dfe2df',
      text: '#191919',
      textDim: '#5b605c',
      accent: '#0f9a5f',
      onAccent: '#ffffff',
      tint: 'rgba(15, 154, 95, 0.1)',
    },
  },
  'swedish-wealth-foundation': {
    logo: 'swi',
    site: 'https://swedishwealthinstitute.com',
    radius: '0.5rem',
    displayFont: ROBOTO,
    bodyFont: ROBOTO,
    dark: {
      bg: '#0c1018',
      surface: '#121826',
      surfaceAlt: '#182031',
      border: '#232d42',
      text: '#f2f5f9',
      textDim: '#93a0b5',
      accent: '#e3b341',
      onAccent: '#14213d',
      tint: 'rgba(227, 179, 65, 0.16)',
    },
    light: {
      bg: '#f6f8fb',
      surface: '#ffffff',
      surfaceAlt: '#f1f5f9',
      border: '#e1e8f0',
      text: '#101828',
      textDim: '#556074',
      accent: '#a8781d',
      onAccent: '#ffffff',
      tint: 'rgba(18, 115, 212, 0.1)',
    },
  },
}
